
import React, { useEffect, Suspense, useState } from 'react';
import { Canvas } from '@react-three/fiber'
import { Html } from '@react-three/drei'
import { Button, Dropdown, MultiSelect } from 'carbon-components-react';
import { WarningAltFilled16, WarningAltInvertedFilled16, CheckmarkFilled20, CheckmarkOutline16, InformationFilled16, ViewFilled16, LightFilled16, WarningFilled20 } from '@carbon/icons-react';
import Scene3D from './Scene3D'
//import data from './data.json'
import i18n from "../../i18n"
import './sap-three.scss'

export const SapTitle = i18n.t('SapMonitoring.SapTitle');
export const ExpandAll = i18n.t('SapMonitoring.ExpandAll');
export const Collapse = i18n.t('SapMonitoring.Collapse');
export const System = i18n.t('SapMonitoring.System');
export const Availability = i18n.t('SapMonitoring.Availability');
export const Performance = i18n.t('SapMonitoring.Performance');
export const Exceptions = i18n.t('SapMonitoring.Exceptions');
const loadingLabel = i18n.t('pageHeader.app.loadingLabel');
const IncidentId = i18n.t('SapMonitoring.IncidentId');
const Name = i18n.t('SapMonitoring.Name');

const lensItems = [
    {
        id: 'Availability',
        label: <div className='lens-dropdown'><CheckmarkFilled20 style={{ fill: "#00539A" }} />{Availability}</div>,
    },
    {
        id: 'Performance',
        label: <div className='lens-dropdown'><div className='lens-symbol'><LightFilled16 className='lens-svg' /></div>{Performance}</div>,
    },
    // {
    //     id: 'Configuration',
    //     label: <div className='lens-dropdown'><div className='lens-symbol'><Settings16 className='len-svg' /></div>Configuration</div>,
    // },
    {
        id: 'Exceptions',
        label: <div className='lens-dropdown'><WarningFilled20 style={{ fill: "#00539A" }} />{Exceptions} </div>
    },
];

let franchiseItems = [{
    id: "option-1",
    label: "client 1"
},
{
    id: "option-2",
    label: "client 2"
}]

const SAPMonitoring = (props) => {
    const [selectedLens, setSelectedLens] = useState("Availability");
    const [selectedLensName, setSelectedLensName] = useState(lensItems[0]);
    const [selectedNodeDetails, setSelectedNodeDetails] = useState([]);
    const [IsExpandCollapse, setIsExpandCollapse] = useState("collapse");
    const [selectedNodeName, setSelectedNodeName] = useState("");

    //to disable double click selection of text in canvas
    let canvas = document.getElementById('canvas');
    useEffect(() => {
        if (canvas) {
            canvas.onselectstart = function () { return false; }
        }
    }, [canvas]);

    const Loader = () => {
        return (
            <Html center style={{ color: "white" }}>
                {loadingLabel}
            </Html>
        );
    };

    const determineStatusIcon = (status) => {
        if (status === 0) {
            return <InformationFilled16 style={{ fill: "#8D8D8D" }} />; //grey
        }
        else if (status === 1) {
            return <CheckmarkOutline16 style={{ fill: "#198038" }} />; //green
        }
        else if (status === 2) {
            return <WarningAltInvertedFilled16 style={{ fill: "#F1C21B" }} />; //yellow
        }
        else if (status >= 3) {
            return <WarningAltFilled16 style={{ fill: "#DA1E28" }} />; //red
        }
        else;
    }

    const handleLensChange = (e) => {
        setSelectedLens(e.id);
        //setSelectedNodeDetails([]);
        setSelectedLensName(e);
    };

    const switchExpandCollapseView = (e) => {
        setIsExpandCollapse(e);
        if (e === "collapse") {
            setSelectedNodeDetails([]); //to empty details on right popup when collapse is clicked
            setSelectedNodeName("")
        }
    };

    const getSelectedNodeDetails = (array, name) => {
        //sort based on status number in desc order
        let selectedNodeDetails = array.length > 0 ? array.sort((a, b) => { if (a.Status > b.Status) { return -1; } else return 1; }) : [];
        setSelectedNodeDetails(selectedNodeDetails);
        setSelectedNodeName(name);
    };

    return (
        <div className='sap-monitoring-container'>
            <div className='canvas-container' >
                <Canvas performance={{ min: 0.5 }}
                    camera={{ position: [18, 18, 25], fov: 85 }} frameloop="demand" shadows="true" id="canvas"
                    onPointerMissed={() => {
                        selectedNodeDetails.length > 0 && setSelectedNodeDetails([]);
                        selectedNodeName !== "" && setSelectedNodeName("");
                    }}
                >
                    <Suspense fallback={<Loader />}>
                        <Scene3D selectedLens={selectedLens} switchExpandCollapseView={switchExpandCollapseView} IsExpandCollapse={IsExpandCollapse}
                            getSelectedNodeDetails={getSelectedNodeDetails} selectedNodeDetails={selectedNodeDetails} />
                    </Suspense>
                </Canvas>
            </div>
            <div className='left-container'>
                <div className='title'>{SapTitle}</div>
                <div className='button-container'>
                    <Button kind='primary' onClick={() => switchExpandCollapseView("expand")} className="expand-button" aria-label='expand-button'>
                        {ExpandAll}
                    </Button>
                    <Button kind='primary' onClick={() => switchExpandCollapseView("collapse")} className="collapse-button" aria-label='collapse-button'>
                        {Collapse}
                    </Button>
                </div>
            </div>

            {/* <div className='filter-container'>
                <MultiSelect
                    ariaLabel="Dropdown"
                    id="lens-dropdown"
                    items={franchiseItems}
                    label={"Franchise"}
                    onChange={(e) => { console.log(e) }}
                    //initialSelectedItem={selectedLensName}
                    itemToElement={item => (item ? item.label : '')}
                />
                <MultiSelect
                    ariaLabel="Dropdown"
                    id="lens-dropdown"
                    items={franchiseItems}
                    label={"Client"}
                    onChange={(e) => { console.log(e) }}
                    //initialSelectedItem={selectedLensName}
                    itemToElement={item => (item ? item.label : '')}
                />
                <Button kind='primary' className="apply-button" size="small" aria-label='apply-button'>
                    Apply
                </Button>
            </div> */}

            <div className='right-container'>
                <>
                    <div className='system-container' >
                        <div className='system-name'>{selectedNodeName && selectedNodeName.length > 0 ? selectedNodeName : System}</div>
                        <div><ViewFilled16 /></div>
                    </div>
                    <Dropdown
                        ariaLabel='lens dropdown'
                        id="lens-dropdown"
                        items={lensItems}
                        label={selectedLens}
                        onChange={(e) => handleLensChange(e.selectedItem)}
                        initialSelectedItem={selectedLensName}
                        size="sm"
                        itemToElement={item => (item ? item.label : '')}
                    />
                    {selectedNodeDetails && selectedNodeDetails.length > 0 && <div className='details-container'>
                        <div className='property-container'>
                            {selectedNodeDetails.map(val => {
                                let Status = val.Status ? parseInt(val.Status) : "";
                                let incidentPath = `/IncidentDetails?alertType=alert&client=${val.Client}&incidentId=${val.IncidentID}&sysId=${val.SysId}&workspace=${props.workspace}`
                                return <div className='details'>
                                    <div>{determineStatusIcon(Status)}</div>
                                    <div>
                                        <div>{IncidentId} : <a href={incidentPath} target="_blank" rel="noreferrer"> {`${val.IncidentID ? val.IncidentID : ""}`}</a></div>
                                        <div>{Name} : {`${val.Name ? val.Name : ""}`}</div>
                                        {val.isParent===true && <div>{System} : {`${val.SystemName ? val.SystemName : ""}`}</div>}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    }
                </>
            </div>
        </div>
    )
};

export default SAPMonitoring;
